import React, { useState } from "react";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebase from "../../../utils/firebase";

import { Link } from "react-router-dom";
import {
  TextField,
  FormControl,
  InputAdornment,
  makeStyles,
} from "@material-ui/core";

import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import LockIcon from "@material-ui/icons/Lock";
import EmailIcon from "@material-ui/icons/Email";
// @material-ui/icons

import CardBody from "components/MaterialKit/Card/CardBody.js";
import CardHeader from "components/MaterialKit/Card/CardHeader.js";

import Button from "components/MaterialKit/CustomButtons/Button.js";
import { CheckFormikValues } from "../../../components/Formik/CheckFormikValues";

import styles from "assets/jss/material-kit-react/views/loginPage.js";
import { REGISTER } from "constants/routes";
import { shallowEqual, useSelector } from "react-redux";

const useStyles = makeStyles(styles);
const LoginForm = (props) => {
  const [uiConfig, setUiConfig] = useState({
    signInFlow: "popup",
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      signInSuccess: () => false,
    },
  });
  const check = false;
  const {
    auth: { loading },
  } = useSelector((state) => {
    return {
      auth: state.auth,
    };
  }, shallowEqual);

  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    handleChange,
  } = props;

  const [view, setView] = useState(false);

  const classes = useStyles();
  return (
    <div style={{ dia: "flex", justifyContent: "center" }}>
      <form onSubmit={handleSubmit} className={classes.form}>
        <CardHeader color="black" className={classes.cardHeader}>
          <h3>Login</h3>
          <div className={classes.socialLine}>
            <StyledFirebaseAuth
              uiConfig={uiConfig}
              firebaseAuth={firebase.auth()}
            />
          </div>
        </CardHeader>
        <p className={classes.divider}>Or </p>
        <CardBody>
          <FormControl style={{ padding: "1rem", width: "100%" }}>
            <TextField
              fullWidth
              variant="outlined"
              label="Email Address or Username"
              placeholder="Enter Email or Username"
              name="text"
              value={values.text}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.text && touched.text}
              helperText={errors.text && touched.text && errors.text}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon />
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
          <FormControl style={{ padding: "1rem", width: "100%" }}>
            <TextField
              variant="outlined"
              label="Password"
              placeholder="Enter Password"
              type={view ? "text" : "password"}
              name="password"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.password && touched.password}
              helperText={
                errors.password && touched.password && errors.password
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {!view ? (
                      <VisibilityIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => setView(!view)}
                      />
                    ) : (
                      <VisibilityOffIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => setView(!view)}
                      />
                    )}
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </CardBody>
        {/* <CardFooter className={classes.cardFooter}> */}
        <div style={{ padding: "1rem" }}>
          <Button
            loading={loading}
            fullWidth
            round
            type="submit"
            color="warning"
            size="lg"
          >
            Login
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            flexDirection: "column",
            padding: "1rem",
          }}
        >
          <div
            style={{
              textAlign: "right",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Link
              to={REGISTER}
              style={{
                textDecoration: "none",
              }}
            >
              Don't have an account?{"  "}
              <Button simple variant="contained" color="primary" size="lg">
                Sign Up
              </Button>
            </Link>
          </div>
        </div>
        {/* </CardFooter> */}
        {check ? <CheckFormikValues {...props} /> : ""}
      </form>
    </div>
  );
};

LoginForm.propTypes = {};

export default LoginForm;
